module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('doc-section', {
    attrs: {
      "id": "input",
      "name": "Input"
    }
  }, [_vm._c('div', {
    staticClass: "bs-example text-left"
  }, [_vm._c('form', {
    attrs: {
      "action": ".",
      "method": "get",
      "accept-charset": "utf-8"
    }
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_vm._c('bs-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    attrs: {
      "name": "username",
      "disabled": _vm.check.disabled,
      "error": _vm.check.error ? 'Insert user name' : null,
      "help": "Only allows lowercase letters and numbers.",
      "enter-submit": _vm.check.enterSubmit,
      "icon": _vm.check.icon,
      "label": _vm.check.label ? 'User Name' : null,
      "mask": _vm.check.mask ? _vm.mask : null,
      "minlength": _vm.check.minlength ? 5 : 0,
      "pattern": "^[a-z][a-z0-9]+$",
      "placeholder": _vm.check.placeholder ? 'Username can\'t start with a number.' : null,
      "readonly": _vm.check.readonly,
      "required": _vm.check.required,
      "hide-help": _vm.check.hideHelp,
      "clear-button": _vm.check.clearButton
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "input": function($event) {
        _vm.input = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_vm._c('bs-input', {
    attrs: {
      "name": "match",
      "required": "",
      "type": "password",
      "match": _vm.input,
      "icon": _vm.check.icon,
      "enter-submit": _vm.check.enterSubmit,
      "help": "Match the User Name"
    }
  }, [_vm._c('label', {
    slot: "label"
  }, [_vm._v("Match value")])])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('button-group', {
    attrs: {
      "type": "primary",
      "buttons": false,
      "disabled": ""
    }
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.label),
      expression: "check.label"
    }],
    domProps: {
      "value": (_vm.check.label)
    },
    on: {
      "input": function($event) {
        _vm.check.label = $event
      }
    }
  }, [_vm._v("Label")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.placeholder),
      expression: "check.placeholder"
    }],
    domProps: {
      "value": (_vm.check.placeholder)
    },
    on: {
      "input": function($event) {
        _vm.check.placeholder = $event
      }
    }
  }, [_vm._v("placeholder")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.hideHelp),
      expression: "check.hideHelp"
    }],
    domProps: {
      "value": (_vm.check.hideHelp)
    },
    on: {
      "input": function($event) {
        _vm.check.hideHelp = $event
      }
    }
  }, [_vm._v("hide help")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.disabled),
      expression: "check.disabled"
    }],
    domProps: {
      "value": (_vm.check.disabled)
    },
    on: {
      "input": function($event) {
        _vm.check.disabled = $event
      }
    }
  }, [_vm._v("disabled")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.error),
      expression: "check.error"
    }],
    domProps: {
      "value": (_vm.check.error)
    },
    on: {
      "input": function($event) {
        _vm.check.error = $event
      }
    }
  }, [_vm._v("error")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.icon),
      expression: "check.icon"
    }],
    domProps: {
      "value": (_vm.check.icon)
    },
    on: {
      "input": function($event) {
        _vm.check.icon = $event
      }
    }
  }, [_vm._v("icon")])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.mask),
      expression: "check.mask"
    }],
    domProps: {
      "value": (_vm.check.mask)
    },
    on: {
      "input": function($event) {
        _vm.check.mask = $event
      }
    }
  }, [_vm._v("mask")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.minlength),
      expression: "check.minlength"
    }],
    domProps: {
      "value": (_vm.check.minlength)
    },
    on: {
      "input": function($event) {
        _vm.check.minlength = $event
      }
    }
  }, [_vm._v("minlength=5")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.readonly),
      expression: "check.readonly"
    }],
    domProps: {
      "value": (_vm.check.readonly)
    },
    on: {
      "input": function($event) {
        _vm.check.readonly = $event
      }
    }
  }, [_vm._v("readonly")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.required),
      expression: "check.required"
    }],
    domProps: {
      "value": (_vm.check.required)
    },
    on: {
      "input": function($event) {
        _vm.check.required = $event
      }
    }
  }, [_vm._v("required")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.clearButton),
      expression: "check.clearButton"
    }],
    domProps: {
      "value": (_vm.check.clearButton)
    },
    on: {
      "input": function($event) {
        _vm.check.clearButton = $event
      }
    }
  }, [_vm._v("clear button")])], 1), _vm._v(" "), _vm._c('p', [_vm._c('checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check.enterSubmit),
      expression: "check.enterSubmit"
    }],
    domProps: {
      "value": (_vm.check.enterSubmit)
    },
    on: {
      "input": function($event) {
        _vm.check.enterSubmit = $event
      }
    }
  }, [_vm._v("enter submit")])], 1)])])], 1), _vm._v(" "), _vm._c('hr'), _vm._v(" "), _vm._c('bs-input', {
    attrs: {
      "label": "Input with slots",
      "type": "text",
      "required": "",
      "icon": "",
      "clear-button": ""
    }
  }, [_vm._c('span', {
    staticClass: "input-group-addon",
    slot: "before"
  }, [_vm._c('span', {
    staticClass: "glyphicon glyphicon-user"
  })]), _vm._v(" "), _vm._c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_vm._c('span', {
    staticClass: "glyphicon glyphicon-question-sign"
  })])]), _vm._v(" "), _vm._c('bs-input', {
    attrs: {
      "name": "textarea",
      "label": "Textarea",
      "type": "textarea",
      "icon": _vm.check.icon,
      "enter-submit": _vm.check.enterSubmit
    },
    on: {
      "focus": function($event) {
        _vm.event = 'focused'
      },
      "blur": function($event) {
        _vm.event = 'blured'
      }
    }
  }), _vm._v(" "), _vm._c('pre', [_vm._v(" Test event on textarea: " + _vm._s(_vm.event))])], 1), _vm._v(" "), _vm._c('doc-code', [_vm._v("\n      <bs-input v-model=\"input\"\n        label=\"Username\"\n        help=\"Only allows lowercase letters and numbers.\"\n        error=\"Insert username\"\n        placeholder=\"Username can't start with a number.\"\n        pattern=\"^[a-z][a-z0-9]+$\"\n        :mask=\"mask\"\n        minlength=\"5\"\n        readonly\n        required\n        icon\n      ></bs-input>\n      <bs-input required label=\"Match value\" type=\"password\"\n        :match=\"input\"\n      ></bs-input>\n      <bs-input label=\"Textarea\" type=\"textarea\"\n        @focus=\"event = 'focused'\"\n        @blur=\"event = 'blured'\"\n      ></bs-input>\n    ")]), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "javascript"
    }
  }, [_vm._v("\n      mask: function (value) {\n        // change to lowercase, remove up to the first letter,\n        // and then remove all other unsuported characters\n        return value.toLowerCase().replace(/^[^a-z]+/,'').replace(/[^a-z0-9]/g,'');\n      }\n    ")]), _vm._v(" "), _vm._c('h2', [_vm._v("Input groups:")]), _vm._v(" "), _vm._c('p', [_vm._v("More details in "), _vm._c('a', {
    attrs: {
      "href": "http://getbootstrap.com/components/#input-groups"
    }
  }, [_vm._v("bootstrap input groups")]), _vm._v(".")]), _vm._v(" "), _vm._c('bs-input', {
    attrs: {
      "label": "With dropdown and button",
      "type": "text"
    }
  }, [_vm._c('dropdown', {
    attrs: {
      "text": "dropdown"
    },
    slot: "before"
  }, [_vm._c('li', [_vm._c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("option")])])]), _vm._v(" "), _vm._c('span', {
    staticClass: "input-group-btn",
    slot: "after"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Go!")])])], 1), _vm._v(" "), _vm._c('doc-code', [_vm._v("\n      <bs-input label=\"With dropdown and button\" type=\"text\">\n        <dropdown slot=\"before\" text=\"dropdown\">\n          <li><a href=\"#\">option</a></li>\n        </dropdown>\n        <span slot=\"after\" class=\"input-group-btn\">\n          <button type=\"button\" class=\"btn btn-primary\">Go!</button>\n        </span>\n      </bs-input>\n    ")]), _vm._v(" "), _vm._c('bs-input', {
    attrs: {
      "label": "With icon and text",
      "type": "number",
      "placeholder": "Insert how much cost your house"
    }
  }, [_vm._c('span', {
    staticClass: "input-group-addon",
    slot: "before"
  }, [_vm._c('span', {
    staticClass: "glyphicon glyphicon-home"
  })]), _vm._v(" "), _vm._c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_vm._v("$")])]), _vm._v(" "), _vm._c('doc-code', [_vm._v("\n      <bs-input label=\"With icon and text\" type=\"number\" placeholder=\"Insert how much cost your house\">\n        <span slot=\"before\" class=\"input-group-addon\"><span class=\"glyphicon glyphicon-home\"></span></span>\n        <span slot=\"after\" class=\"input-group-addon\">$</span>\n      </bs-input>\n    ")]), _vm._v(" "), _vm._c('bs-input', {
    attrs: {
      "label": "With datalist (new on html5)",
      "type": "text",
      "placeholder": "Insert a fruit",
      "datalist": _vm.fruits
    }
  }), _vm._v(" "), _vm._c('doc-code', [_vm._v("\n      <bs-input label=\"With datalist\" type=\"text\" placeholder=\"Insert a fruit\" :datalist=\"fruits\">\n      </bs-input>\n    ")])], 1), _vm._v(" "), _vm._c('doc-table', [_vm._c('div', [_vm._c('p', [_vm._v("value")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("''")])]), _vm._v(" "), _vm._c('p', [_vm._v("Input value. Use "), _vm._c('code', [_vm._v("v-model=\"value\"")])])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("datalist")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Array")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("\n        A list of predefined values that you can select. Work closer to an autocomplete. The items must be "), _vm._c('code', [_vm._v("String")]), _vm._v(" values.\n      ")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("disabled")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("false")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("enterSubmit")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("false")])]), _vm._v(" "), _vm._c('p', [_vm._v("Submit when you press "), _vm._c('code', [_vm._v("Enter")]), _vm._v(". Not supported on type "), _vm._c('code', [_vm._v("textarea")]), _vm._v(".")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("error")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("Error message.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("help")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("Help text behind the input")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("hide-help")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("true")])]), _vm._v(" "), _vm._c('p', [_vm._v("Only work with help and error."), _vm._c('br'), _vm._v("Hide the help if have to show any error message.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("icon")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("false")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("label")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("Enable input label (name).")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("lang")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._v("Browser language")]), _vm._v(" "), _vm._c('p', [_vm._c('abbr', {
    attrs: {
      "title": "ISO 639-1 code"
    }
  }, [_vm._c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes"
    }
  }, [_vm._v("Language")])]), _vm._v(". Default "), _vm._c('code', [_vm._v("en")]), _vm._v(" if the translation doesn't exist.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("mask")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Function")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("Mask function that receive and edit the value.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("mask-delay")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Number")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("100")])]), _vm._v(" "), _vm._c('p', [_vm._v("Delay time before apply the mask.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("match")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("''")])]), _vm._v(" "), _vm._c('p', [_vm._v("Matching value. Both have to be the same value.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("maxlength")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Number")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("minlength")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Number")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("0")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("name")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("pattern")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")]), _vm._v(", "), _vm._c('code', [_vm._v("RegExp")]), _vm._v(" or "), _vm._c('code', [_vm._v("Function")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("Validation pattern. A full "), _vm._c('a', {
    attrs: {
      "href": "https://developer.mozilla.org/es/docs/Web/JavaScript/Guide/Regular_Expressions",
      "target": "_blank"
    }
  }, [_vm._v("regular expression")]), _vm._v(" or a function that evaluate the content and return "), _vm._c('code', [_vm._v("true")]), _vm._v(" or "), _vm._c('code', [_vm._v("false")]), _vm._v(".")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("placeholder")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("required")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("false")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("type")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("text")])]), _vm._v(" "), _vm._c('p')]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("url")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("url for a datalist.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("url-map")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Function")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("null")])]), _vm._v(" "), _vm._c('p', [_vm._v("A map function that handle the data receibed from the url.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("validation-delay")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Number")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("250")])]), _vm._v(" "), _vm._c('p', [_vm._v("Delay time before apply the validation.")])])]), _vm._v(" "), _vm._c('doc-table', {
    attrs: {
      "name": "Supported Native Validator",
      "headers": ['Name', 'Description']
    }
  }, [_vm._c('div', [_vm._c('p', [_vm._v("type")]), _vm._v(" "), _vm._c('p', [_vm._v("Use native validation with "), _vm._c('code', [_vm._v("url")]), _vm._v(" and "), _vm._c('code', [_vm._v("email")]), _vm._v(".")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("min / max / step")]), _vm._v(" "), _vm._c('p', [_vm._v("That attributes handle the values supported.\n        Work with the following input types: "), _vm._c('code', [_vm._v("number")]), _vm._v(", "), _vm._c('code', [_vm._v("range")]), _vm._v(", "), _vm._c('code', [_vm._v("date")]), _vm._v(", "), _vm._c('code', [_vm._v("datetime-local")]), _vm._v(", "), _vm._c('code', [_vm._v("month")]), _vm._v(", "), _vm._c('code', [_vm._v("time")]), _vm._v(" and "), _vm._c('code', [_vm._v("week")]), _vm._v(".")])])]), _vm._v("\n  That validations only work in browsers that support "), _vm._c('a', {
    attrs: {
      "href": "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Forms/Data_form_validation",
      "target": "_blank"
    }
  }, [_vm._v("HTML5 form validations (all modern browsers support it).")])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-646fbd5b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-646fbd5b!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/inputDocs.vue
// module id = 215
// module chunks = 0